export default "__VITE_ASSET__DJlS6F0S__";